// extracted by css-extract-rspack-plugin
export default {"EmbeddingOptionIcon":"EmbeddingOption-module__EmbeddingOptionIcon___aK6Ul","Disabled":"EmbeddingOption-module__Disabled___KkFS8"};